/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Rows_0_1Inputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_3_table_rows_0_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Rows_0_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read and write support. Validate formulas and workbook features after export; full Excel fidelity is not guaranteed.`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_3_table_rows_0_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Rows_0_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持读取和写入。导出后仍需验证公式及工作簿功能，不能保证与 Excel 完全一致。`)
};

/**
* | output |
* | --- |
* | "Read and write support. Validate formulas and workbook features after export; full Excel fidelity is not guaranteed." |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Rows_0_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_3_table_rows_0_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Rows_0_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Rows_0_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_3_table_rows_0_1(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_3_table_rows_0_1(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_3_table_rows_0_1 as "gc.search_guides.gridcraft_excel_compatibility.sections.3.table.rows.0.1" }